import {ConnectionStatus, TERMINAL_SESSION_STATES} from '../types/session'
import type {SessionState as SessionStateType} from '../types/session'

/**
 * Computes connection status for a CLI session.
 * Returns undefined when isCLI is false.
 *
 * Uses `dataUpdatedAt` (from React Query) instead of `Date.now()` to determine
 * whether the staleAt deadline has passed. This keeps the function pure and
 * React Compiler-safe — the only time source is the reactive `dataUpdatedAt`
 * prop, which triggers re-renders on each poll cycle.
 */
export function computeConnectionStatus(
  staleAt: string | undefined,
  isCLI: boolean,
  sessionState?: SessionStateType,
  dataUpdatedAt?: number,
): ConnectionStatus | undefined {
  if (!isCLI) return undefined

  if (sessionState && TERMINAL_SESSION_STATES.has(sessionState)) {
    return ConnectionStatus.Disconnected
  }

  if (!staleAt) return ConnectionStatus.Disconnected

  const deadline = new Date(staleAt).getTime()

  // If we haven't fetched data yet, or our latest fetch predates the deadline,
  // the session is still considered connected.
  if (dataUpdatedAt === undefined || dataUpdatedAt < deadline) {
    return ConnectionStatus.Connected
  }

  return ConnectionStatus.Disconnected
}
